import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule, Routes } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "app/helper-components/Shared.module";
import { AlertsWelcomeComponent } from "./alerts-welcome.component";

const routes: Routes = [
  {
    path: "alerts-welcome",
    component: AlertsWelcomeComponent,
  },
];

@NgModule({
  declarations: [AlertsWelcomeComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatStepperModule,
    FuseSharedModule,
    MatButtonModule,
    SharedModule,
    MatIconModule,
    TranslateModule
  ]
})
export class AlertsWelcomeModule { }
